import Loadable from '@loadable/component'

export const AdvancePaymentCalculator = Loadable(
  /* webpackChunkName: "AdvancePaymentCalculator" */
  /* webpackPrefetch: "true" */
  /* #__LOADABLE__ */
  () => import('./AdvancePaymentCalculator'),
)
